// extracted by mini-css-extract-plugin
export default {"tooltip":"tooltip-14MtrL","arrow":"arrow-1HBDh2","tooltipTarget":"tooltipTarget-2UJ5fn"};